import { Placement } from 'react-joyride';
import { BaseTour } from '../BaseTour';

export class RateCardProviderSelectionTour extends BaseTour {
  id = 'rate-card-provider-selection';

  content = 'Rate Card Manager - Service Provider Selection';

  placement: Placement = 'top';

  steps = {
    serviceProviderSelection: () => ({
      content: 'Click on any service provider card to navigate to their shipping services table. The tour will continue automatically on the next page.',
      placement: 'top' as Placement,
    }),
  } as const;
}
